module.exports = __webpack_public_path__ + "img/T5-A-xs_01.84909c46.png";